import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    getRepertoireSuccess,
    getRepertoireFail,

    getAllRepertoiresSuccess,
    getAllRepertoiresFail,

    getRepertoireTreeSuccess,
    getRepertoireTreeFail,

    getAuthorizedRepertoireTreeSuccess,
    getAuthorizedRepertoireTreeFail,

    getRepertoiresByStatusSuccess,
    getRepertoiresByStatusFail,

    createRepertoireSuccess,
    createRepertoireFail,

    updateRepertoireSuccess,
    updateRepertoireFail,

    changeRepertoireStatusSuccess,
    changeRepertoireStatusFail,

    deleteRepertoireSuccess,
    deleteRepertoireFail,

    setRepertoireLoading
} from "../actions/repertoireActions";

import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    patchRequest,
    deleteRequest
} from "../../../api";

const getUidHeader = () => {
    const uid = sessionStorage.getItem("uid") || localStorage.getItem("uid");
    return uid ? { uid } : {};
};
export const getUidHeaderAndToken = () => ({
    uid: sessionStorage.getItem("uid"),
    token: sessionStorage.getItem("token"),
});

export function* getRepertoireSaga(action) {
    const url = `${API_BASE_URL}/api/repertoires/${action.payload.id}`;
    const headers = getUidHeader();

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(getRequest, { url, headers });
        yield put(getRepertoireSuccess(resp.data));
    } catch (error) {
        yield put(getRepertoireFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* getAllRepertoiresSaga() {
    const url = `${API_BASE_URL}/api/repertoires`;
    const headers = getUidHeader();

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(getRequest, { url, headers });
        yield put(getAllRepertoiresSuccess(resp.data));
    } catch (error) {
        yield put(getAllRepertoiresFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* getRepertoireTreeSaga() {
    const url = `${API_BASE_URL}/api/repertoires/tree`;
    const headers = getUidHeader();

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(getRequest, { url, headers });
        yield put(getRepertoireTreeSuccess(resp.data));
    } catch (error) {
        yield put(getRepertoireTreeFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* getAuthorizedRepertoireTreeSaga() {
    const url = `${API_BASE_URL}/api/repertoires/tree/authorized`;
    const headers = getUidHeader();

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(getRequest, { url, headers });
        yield put(getAuthorizedRepertoireTreeSuccess(resp.data));
    } catch (error) {
        yield put(getAuthorizedRepertoireTreeFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* getRepertoiresByStatusSaga(action) {
    const url = `${API_BASE_URL}/api/repertoires/status/${action.payload.status}`;
    const headers = getUidHeader();

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(getRequest, { url, headers });
        yield put(getRepertoiresByStatusSuccess(resp.data));
    } catch (error) {
        yield put(getRepertoiresByStatusFail(error.response?.data?.message || error.message));
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* createRepertoireSaga(action) {
    const url = `${API_BASE_URL}/api/repertoires`;
    const headers = getUidHeader();
    const data = action.payload;

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(postRequest, { url, data, headers });
        yield put(createRepertoireSuccess(resp.data));
        yield put({ type: 'GET_REPERTOIRE_TREE_REQUEST' });

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: 'Répertoire créé avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(createRepertoireFail(error.response?.data?.message || error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: error.response?.data?.message || 'Erreur lors de la création',
            confirmButtonText: 'OK'
        });
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* updateRepertoireSaga(action) {
    const url = `${API_BASE_URL}/api/repertoires/${action.payload.id}`;
    const headers = getUidHeader();
    const data = action.payload.data;

    yield put(setRepertoireLoading(true));
    try {
        const resp = yield call(putRequest, { url, data, headers });
        yield put(updateRepertoireSuccess(resp.data));
        yield put({ type: 'GET_REPERTOIRE_TREE_REQUEST' });

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: 'Répertoire mis à jour avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(updateRepertoireFail(error.response?.data?.message || error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: error.response?.data?.message || 'Erreur lors de la mise à jour',
            confirmButtonText: 'OK'
        });
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* changeRepertoireStatusSaga(action) {
    const { id, status } = action.payload;
    const url = `${API_BASE_URL}/api/repertoires/${id}/status?status=${status}`;
    const headers = getUidHeaderAndToken();
    const uid = sessionStorage.getItem("uid");
    const token = sessionStorage.getItem("token");

    yield put(setRepertoireLoading(true));
    try {

        const resp = yield call(patchRequest, { url, data: {}, uid, token });
        yield put(changeRepertoireStatusSuccess(resp.data));
        yield put({ type: 'GET_REPERTOIRE_TREE_REQUEST' });

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: 'Statut mis à jour avec succès',
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(changeRepertoireStatusFail(error.response?.data?.message || error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: error.response?.data?.message || 'Erreur lors du changement de statut',
            confirmButtonText: 'OK'
        });
    } finally {
        yield put(setRepertoireLoading(false));
    }
}

export function* deleteRepertoireSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/repertoires/${id}`;
    const headers = getUidHeader();

    yield put(setRepertoireLoading(true));
    try {
        yield call(deleteRequest, { url, headers });
        yield put(deleteRepertoireSuccess(id));
        yield put({ type: 'GET_REPERTOIRE_TREE_REQUEST' });

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: 'Répertoire archivé avec succès',
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(deleteRepertoireFail(error.response?.data?.message || error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: error.response?.data?.message || 'Erreur lors de la suppression',
            confirmButtonText: 'OK'
        });
    } finally {
        yield put(setRepertoireLoading(false));
    }
}